import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';

import { SearchInput, StatusBullet } from 'components';
import { 
  Typography, 
  TextField, 
  MenuItem,
  Button,
  IconButton, 
} from '@material-ui/core';

import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

import { areas, groups } from 'common/datas';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  rowIcons: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    //paddingLeft: theme.spacing(8),
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  // row1: {
  //   width: '240px',
  //   display: 'flex',
  //   alignItems: 'center',
  //   marginLeft: theme.spacing(6),
  //   '& > *': {
  //     marginLeft: theme.spacing(0),
  //     margin: theme.spacing(1),
  //   },
  // },
  spacer: {
    flexGrow: 1
  },
  Button: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  searchInput: {
    marginRight: theme.spacing(1)
  },
  registerListItemTitle: {
    marginLeft: theme.spacing(2),
    width: '100px',
  },
  registerListItemInput: {
    //marginLeft: theme.spacing(2),
    width: '240px',
    //height: '40px',
  },
}));

const AgencyToolbar = props => {
  //const { className, ...rest } = props;

  const { 
    className, 
    onClickSearch,
    ...rest
  } = props;

  const classes = useStyles();

  const [agencyName, setAgencyName] = useState('');

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <div className={classes.row}>
        <Typography
          className={classes.registerListItemTitle}
          color="textSecondary"
          gutterBottom
        >
          광고대행사명
        </Typography>

        <SearchInput
          className={classes.searchInput}
          placeholder=""
          value={agencyName}
          onChange={e => setAgencyName(e.target.value)}
        />
        
        <Button
          color="primary"
          variant="contained"
          onClick={ () => onClickSearch(agencyName) }
        >
          조회
        </Button>
       
      </div>
     
    </div>
  );
};

AgencyToolbar.propTypes = {
  className: PropTypes.string
};

export default AgencyToolbar;
